import { gql } from 'graphql-request';

export const CACHE_CHECK_AND_PAY_PAYPAL_BY_ORDER_ID_QUERY = gql`
  mutation CacheCheckAndPayPaypalByOrderId($orderId: String!) {
    checkAndPayPaypalByOrderId(input: { orderId: $orderId }) {
      content
      status
    }
  }
`;
